/**
 * Dependencies.
 */
import { Services } from '@prz-dp/services';
import Vue from 'vue';

import applicationConstant from '@/modules/main/constants/application.constant';
import router from '@/plugins/router.plugin';
import store from '@/plugins/store.plugin';

/**
 * Use `Services`.
 */
Vue.use(Services, {
  options: applicationConstant,
  router,
  store
});
